import {createContext} from 'react';
import {useContext} from 'react';

export type Employee = {
  id: string;
  employeeNumber: string;
  name: string;
  onBoardingDate: string;
};
export interface CompanyContext {
  code: string;
  vat: string;
  name: string;
  seniorityId: string;
  customerId: number;
  account: string;
  amountOfLicense: number;
  step: number;
  employee: Employee[];
  companyId: string;
  enablePY: boolean;
}

const CompanyStore = createContext<CompanyContext>({
  account: '',
  amountOfLicense: 0,
  code: '',
  customerId: 0,
  name: '',
  seniorityId: '',
  step: 0,
  vat: '',
  employee: [],
  companyId: '',
  enablePY: true,
});

export function useCompanyContext() {
  return useContext(CompanyStore);
}

export default CompanyStore;
